if (customElements.get('research-database-filter') === undefined) {
  class ResearchDatabaseFilter extends HTMLElement {
    connectedCallback() {
      const sectionId = this.getAttribute('section-id');
      if (!sectionId) return;

      this.filtersEl = this.querySelector('[data-rdb-filters]');
      this.sliderWrapper = document.getElementById('rdb-slider-wrapper-' + sectionId);

      if (!this.filtersEl || !this.sliderWrapper) return;

      this.sortByDate();

      this.filtersEl.addEventListener('click', (e) => {
        const btn = e.target.closest('.rdb-filter-btn');
        if (!btn) return;
        this.applyFilter(btn);
      });
    }

    sortByDate() {
      const wrapper = this.sliderWrapper.querySelector('.swiper-wrapper');
      const slides = Array.from(wrapper.querySelectorAll('.swiper-slide[data-entry-type]'));
      slides.sort((a, b) => {
        const dateA = a.dataset.createdAt ? new Date(a.dataset.createdAt).getTime() : 0;
        const dateB = b.dataset.createdAt ? new Date(b.dataset.createdAt).getTime() : 0;
        return dateB - dateA; // newest first
      });
      slides.forEach((slide) => wrapper.appendChild(slide));
    }

    applyFilter(activeBtn) {
      const filter = activeBtn.dataset.filter;

      this.filtersEl.querySelectorAll('.rdb-filter-btn').forEach((btn) => {
        btn.classList.remove('bg-dark-green-default', 'text-white');
        btn.classList.add('bg-white', 'text-dark-green-80', 'border-gray-300');
      });

      activeBtn.classList.add('bg-dark-green-default', 'text-white');
      activeBtn.classList.remove('bg-white', 'text-dark-green-80', 'border-gray-300');

      const slides = this.sliderWrapper.querySelectorAll('.swiper-slide[data-entry-type]');
      slides.forEach((slide) => {
        slide.style.display = filter === 'all' || slide.dataset.entryType === filter ? '' : 'none';
      });

      const swiperEl = this.sliderWrapper.querySelector('.swiper-container');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
        swiperEl.swiper.slideTo(0, 0);
      }
    }
  }

  customElements.define('research-database-filter', ResearchDatabaseFilter);
}
